<template>
    <div>
        <div class="search-box">
            <p>自然年：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY'
                v-model="searchFrom.year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="searchFrom.year" />
            </a-date-picker>
            <p v-if="permissions.indexOf('research:assess:queryAll')>-1">部门：</p>
            <a-tree-select
                v-if="permissions.indexOf('research:assess:queryAll')>-1"
                class="input-box"
                showSearch
                v-model="selectedDeployment"
                labelInValue
                :treeData="departmentTree"
                :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                allowClear
                treeNodeFilterProp="title"
                treeDefaultExpandAll
                @change="onChangeDep"
                >
            </a-tree-select>
            <p v-if="permissions.indexOf('research:assess:queryAll')>-1">职称：</p>
            <a-select v-if="permissions.indexOf('research:assess:queryAll')>-1" class="input-box" allowClear v-model="searchFrom.technicalTitleCode">
                <a-select-option v-for="(item,index) in zcArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
             <p v-if="permissions.indexOf('research:assess:queryAll')>-1">状态：</p>
            <a-select v-if="permissions.indexOf('research:assess:queryAll')>-1" class="input-box" allowClear v-model="searchFrom.approveStatus">
                <a-select-option v-for="(item,index) in ztArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p v-if="permissions.indexOf('research:assess:queryAll')>-1">教师姓名：</p>
            <a-input v-if="permissions.indexOf('research:assess:queryAll')>-1" class="input-box" v-model="searchFrom.teacherName" allowClear/>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
        </div>
        <div class="operation-box">
            <!-- <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="selectedRowKeys[0] == null ? selectedCheck() :remove(selectedRowKeys[0])">
                <a-button 
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    v-if="permissions.indexOf('undergraduate:culture:classroom:delete')>-1">
                    删除
                </a-button>
            </a-popconfirm> -->
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() :$router.push('/admin/research/assess/info?type=add&assessId='+selectedRowKeys[0])"
                v-if="permissions.indexOf('research:assess:add')>-1" :disabled='!tb'>
                 填报
            </a-button>
            <a-button 
                type="primary"
                icon="check" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() :$router.push('/admin/research/assess/info?type=approve&assessId='+selectedRowKeys[0])"
                v-if="permissions.indexOf('research:assess:approve')>-1" :disabled='!sh'>
                 审核
            </a-button>
            <a-button 
                type="primary"
                icon="check" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() :$router.push('/admin/research/assess/info?type=confirm&assessId='+selectedRowKeys[0])"
                v-if="permissions.indexOf('research:assess:confirm')>-1" :disabled='!qr'>
                 确认
            </a-button>
            <a-button 
                type="primary"
                icon="book" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() :$router.push('/admin/research/assess/info?type=look&assessId='+selectedRowKeys[0]+'&approvalStatus='+approvalStatus)"
                v-if="permissions.indexOf('research:assess:query')>-1">
                 查看
            </a-button>
            <a-button type="primary" class="btn" icon="download" v-if="permissions.indexOf('research:assess:query')>-1"  @click="selectedRowKeys[0] == null ? selectedCheck() :exportTable()">导出Excel</a-button>

        </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
            <!-- <template slot="taskSource" slot-scope="text,record">
                <a-select class="show-input" v-model="record.taskSource" disabled>
                    <a-select-option v-for="(item,index) in rwlyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template> -->
            <!-- <template slot="id" slot-scope="text,record">
                <a class="action-btn" @click="$router.push('/admin/undergraduate/quality/classroom/info?type=look&id='+text)">详情</a>
                <a-divider type="vertical" v-if='record.judgeTeacherId == judgeTeacherId'/>
                    <a class="action-btn" v-if='record.judgeTeacherId == judgeTeacherId' @click="$router.push('/admin/undergraduate/quality/classroom/info?type=update&id='+text)">编辑</a>
                <a-divider type="vertical" v-if='record.judgeTeacherId == judgeTeacherId'/>
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                    v-if='record.judgeTeacherId == judgeTeacherId'
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template> -->
        </a-table>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,exportTable } from '@/baseAPI/research/assess'
    import { getSchoolYear,selectedCheck } from '@/baseAPI/util'
    import { queryDepartmentTreeList } from '@/baseAPI/department'
   
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                selectedDeployment:{},
                selectedRowKeys: [],
                permissions:[],
                columns:[
        {
            title: '序号',
            dataIndex: 'id',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '姓名',
            dataIndex: 'teacherName',
            align:'center',
        },
        {
            title: '部门',
            dataIndex: 'orgName',
            align:'center'
        },
        {
            title: '职称',
            dataIndex: 'technicalTitleName',
            align:'center',
        },
        {
            title: '人员类别',
            dataIndex: 'staffCategoryName',
            align:'center',
        },
        {
            title: '人事绩效系统（科研）总分',
            dataIndex: 'hrScore',
            align:'center'
        },
        {
            title: '科研得分分项',
            align:'center',
            children: [
                {
                    title: '理工类',
                    dataIndex: 'lgl',
                    align:'center'
                },
                {
                    title: '人文社科类',
                    dataIndex: 'rwskl',
                    align:'center'
                },
                {
                    title: '科研会议',
                    dataIndex: 'kyhy',
                    align:'center',
                },
                {
                    title: '其他',
                    dataIndex: 'qt',
                    align:'center',
                }
            ]
        },
        {
            title: '学院核定总分',
            dataIndex: 'totalScore',
            align:'center'
        },
        {
            title: '状态',
            dataIndex: 'approvalStatus',
            align:'center',
            customRender: (text, row, index) => {
                let ztName = ''
                this.ztArr.forEach(zt=>{
                    if(zt.dataCode == text){
                        ztName = zt.dataName
                        return;
                    }
                })
                return ztName;
            },
        },
        {
            title: '更新日期',
            dataIndex: 'lastUpdateTime',
            align:'center',
        }

    ],
                data:[],
                zcArr:[],
                ztArr:[],
                loading: false,
                lastTime:'',
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    year:'',
                    technicalTitleCode:'',
                    orgCode:''

                },
                rwlyArr:[],
                kpdjArr:[],
                judgeTeacherId:'',
                yearShowOne:false,
                tb:false,
                sh:false,
                qr:false,
                approvalStatus:null
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.judgeTeacherId = this.$store.state.user.userId
            getDicts({dataCode:'KTJXZL_RWLY',status:true}).then(res=>{
                this.rwlyArr=res.data.dicts;
            })
            getDicts({dataCode:'KPDJ',status:true}).then(res=>{
                this.kpdjArr=res.data.dicts;
            })
            getDicts({dataCode:'ZC',status:true}).then(res=>{
                this.zcArr=res.data.dicts;
            })
            getDicts({dataCode:'KYCG-ZT',status:true}).then(res=>{
                this.ztArr=res.data.dicts;
            })
            if(typeof this.$route.query.name!='undefined'){
                this.searchFrom.teacherName=this.$route.query.tearch;
                this.searchFrom.courseName=this.$route.query.name;
            }
            this.fetch()
            this.searchFrom.year='2023'
            queryDepartmentTreeList().then(res => {
                this.departmentTree = res.data
            })
        },
        methods:{
            ztCheck(){
                this.data.forEach(e=>{
                    if(e.id==this.selectedRowKeys[0]){
                        this.approvalStatus = e.approvalStatus
                        if(e.approvalStatus == 'init' || e.approvalStatus == 'saved'){
                            this.tb = true
                            this.sh = false
                            this.qr = false
                        }else if(e.approvalStatus == 'commit'){
                            this.sh = true
                            this.tb = false
                            this.qr = false
                        }else if(e.approvalStatus == 'approved'){
                            this.qr = true
                            this.tb = false
                            this.sh = false
                        }else{
                            this.tb = false
                            this.sh = false
                            this.qr = false
                        }
                    }
                })
            },
            exportTable(){
                exportTable(this.selectedRowKeys[0]).then(res => {
                    window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                })
            }, 
            zt(zt){
                var ztName = '';
                this.ztArr.forEach(item=>{
                    if(item.dataCode == zt){
                        ztName =  item.dataName;
                        return;
                    }
                })
                return ztName;
            },
            onChangeDep (obj) {
                this.selectedDeployment=obj;
                if(obj){
                    this.searchFrom.orgCode = obj.value;
                }else{
                    this.searchFrom.orgCode = '';
                }
            },
            selectedCheck(){
                selectedCheck()
            },
            exportFile(id){
                if(this.selectedRowKeys.length>0){
                    exportFile(id).then(res=>{
                        if(res){
                            this.$notification['success']({
                                message: '成功',
                                description:'导出听课评价成功',
                            });
                            window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择听课评价后再进行导出',
                    });
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.searchFrom.year=this.getTimeStr(value._d,'yyyy')
                this.yearShowOne = false;
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                this.ztCheck();
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    if(this.data.length > 0){
                        this.onSelectChange([this.data[0].id])
                    }
                    this.loading = false;
                })
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除课堂教学质量成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 12rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .table-tips{
        margin-top: -48px;
        line-height: 32px;
        padding-left: 15px;
        color: #aaa;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }

</style>
